export var ContentSourceType;
(function (ContentSourceType) {
    ContentSourceType["URL"] = "URL";
    ContentSourceType["UNLAYER"] = "UNLAYER";
    ContentSourceType["CUSTOM_HTML"] = "CUSTOM_HTML";
})(ContentSourceType || (ContentSourceType = {}));
export var ContentType;
(function (ContentType) {
    ContentType["POST"] = "POST";
    ContentType["APP_DATA"] = "APP_DATA";
})(ContentType || (ContentType = {}));
